'use strict';

var skeleton = require('../../../../../../../../../../_virtual/skeleton.cjs');

var hasRequiredSkeleton;

function requireSkeleton () {
	if (hasRequiredSkeleton) return skeleton.__exports;
	hasRequiredSkeleton = 1;

	var SkeletonAviaryTypes = /*#__PURE__*/ function(SkeletonAviaryTypes) {
	    SkeletonAviaryTypes["button"] = "button";
	    SkeletonAviaryTypes["typography"] = "typography";
	    SkeletonAviaryTypes["avatar"] = "avatar";
	    return SkeletonAviaryTypes;
	}({});

	skeleton.__exports.SkeletonAviaryTypes = SkeletonAviaryTypes;
	
	return skeleton.__exports;
}

exports.__require = requireSkeleton;
//# sourceMappingURL=skeleton.cjs.map
